import {createContext, useContext} from 'react';

const ThemeContext = createContext()

//only read
export const useThemeContext = () => useContext(ThemeContext) //equal ThemeContext.Consumer

export default ThemeContext;